import { toDash, serializeLocale } from 'utils/intl'
import Cookies from 'js-cookie'

import { normalizeMessages } from 'models/configurations'

const NOTIFICATION = 'react-template/app/NOTIFICATION'
const CHANGE_LOCALE = 'react-template/app/CHANGE_LOCALE'
const TOGGLE_MODAL = 'react-template/app/TOGGLE_MODAL'
const TOGGLE_ALERT = 'react-template/app/TOGGLE_ALERT'
const TOGGLE_NESTED_MODAL = 'react-template/app/TOGGLE_NESTED_MODAL'
const GET_API_VERSION = 'dofe/app/GET_API_VERSION'
const GET_API_VERSION_SUCCESS = 'dofe/app/GET_API_VERSION_SUCCESS'
const GET_API_VERSION_FAIL = 'dofe/app/GET_API_VERSION_FAIL'
const REFRESH_PAGE = 'react-template/app/REFRESH_PAGE'
const ON_ERROR = 'react-template/app/ON_ERROR'
const SET_NETWORK_STATUS = 'dofe/app/SET_NETWORK_STATUS'
const NO_API_CONNECTION = 'dofe/app/NO_API_CONNECTION'
const GET_LOCALIZED_MESSAGES = 'react-template/app/GET_LOCALIZED_MESSAGES'
const GET_LOCALIZED_MESSAGES_SUCCESS = 'react-template/app/GET_LOCALIZED_MESSAGES_SUCCESS'
const GET_LOCALIZED_MESSAGES_FAIL = 'react-template/app/GET_LOCALIZED_MESSAGES_FAIL'

export default ({ locale } = {}) => {
  const initialState = {
    apiVersion: null,
    notification: {
      message: '',
      level: '',
      options: {},
      active: false,
    },
    locale: locale
      ? serializeLocale(locale)
      : {
          id: 2,
          short: 'en',
          name: 'Select language',
          code: 'en-gb',
        },
    messages: {},
    modal: {
      id: null,
      next: null,
      data: null,
      nestedId: null,
    },
    alert: {
      id: null,
      data: null,
    },
    misc: {
      refreshPage: false,
      manualLanguageSwitch: false,
      noConnection: false,
      noApiConnection: false,
    },
    error: {},
    isOnline: true,
  }

  return (state = initialState, action = {}) => {
    switch (action.type) {
      case NOTIFICATION:
        return Object.assign({}, state, {
          notification: {
            message: action.message,
            level: typeof action.options === 'string' ? action.options : 'info',
            options: typeof action.options === 'object' ? action.options : {},
            active: action.active === undefined,
          },
        })

      case CHANGE_LOCALE:
        return {
          ...state,
          locale: {
            ...state.locale,
            ...action.locale,
          },
        }

      case TOGGLE_MODAL:
        return Object.assign({}, state, {

          modal: {
            id: action.id,
            next: action.next,
            data: action.data,
          },
        })

      case TOGGLE_NESTED_MODAL:
        return {
          ...state,
          modal: {
            ...state.modal,
            nestedId: action.id,
          },
        }

      case TOGGLE_ALERT:
        return Object.assign({}, state, {
          alert: {
            id: action.id,
            data: action.data,
          },
        })

      case GET_API_VERSION_SUCCESS:
        return {
          ...state,
          apiVersion: action.result.version,
        }

      case REFRESH_PAGE:
        return {
          ...state,
          misc: {
            ...state.misc,
            refreshPage: true,
          },
        }
      case NO_API_CONNECTION:
        return {
          ...state,
          misc: {
            ...state.misc,
            noApiConnection: action.bool,
          },
        }
      case ON_ERROR:
        return {
          ...state,
          error: {
            ...action.error,
            options: action.options,
          },
        }
      case SET_NETWORK_STATUS:
        return {
          ...state,
          isOnline: action.isOnline,
        }
      case GET_LOCALIZED_MESSAGES:
        return Object.assign({}, state, {
          messages: {},
        })
      case GET_LOCALIZED_MESSAGES_SUCCESS:
       return Object.assign({}, state, {
          messages: {
            ...state.messages,
            [toDash(action.code) || 'en-gb']: normalizeMessages(
              typeof action.result === 'string' ? JSON.parse(action.result) : action.result
            )
          },
        })
      case GET_LOCALIZED_MESSAGES_FAIL:
        // if failed and messages are null then local messages will be loaded
        console.log('FAIL')
        return {
          ...state,
          messages: {},
        }
      default:
        return state
    }
  }
}

export function notification(message, options, active) {
  return {
    type: NOTIFICATION,
    message,
    options,
    active,
  }
}

export function changeLocale(locale) {
  const parsed = typeof(locale) === 'string'  // sometimes (maybe when returning from BO?) the locale is double encoded
    ? JSON.parse(locale)
    : locale

  const serialized = serializeLocale(parsed)

  Cookies.set('locale', serialized, { secure: true })

  return {
    type: CHANGE_LOCALE,
    locale: serialized,
  }
}

export function modal(id, next, data) {
  return {
    type: TOGGLE_MODAL,
    id,
    next,
    data,
  }
}

export function nestedModal(id) {
  return {
    type: TOGGLE_NESTED_MODAL,
    id,
  }
}

export function alert(id, next, data) {
  return {
    type: TOGGLE_ALERT,
    id,
    next,
    data,
  }
}

export function noApiConnection(bool) {
  return {
    type: NO_API_CONNECTION,
    bool,
  }
}

export function getApiVersion() {
  return {
    types: [GET_API_VERSION, GET_API_VERSION_SUCCESS, GET_API_VERSION_FAIL],
    promise: client => client.get('api/version'),
  }
}

export function onRefreshPage(bool) {
  return {
    type: REFRESH_PAGE,
    bool,
  }
}


export function logError(error, options) {
  return {
    type: ON_ERROR,
    error,
    options,
  }
}

export function toggleOnlineStatus(isOnline = false) {
  return {
    type: SET_NETWORK_STATUS,
    isOnline,
  }
}

export function getLocalizedMessages(code) {
  return {
    types: [GET_LOCALIZED_MESSAGES, GET_LOCALIZED_MESSAGES_SUCCESS, GET_LOCALIZED_MESSAGES_FAIL],
    promise: client => client.get('/poe-translations'),
    code,
  }
}
